import { Form } from "types";
import { useAutoFetchCollection } from "../useAutoFetchCollection";

export const useForms = () => {
    // we want partner experiences to load into products as well
    const { data: forms, isLoading, isSuccess } = useAutoFetchCollection<Form>("forms");

    return { data: forms, isLoading, isSuccess };
};
